module.exports = __webpack_public_path__ + "static/img/4.e50fcad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/4.jpg
// module id = pFkL
// module chunks = 0